import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import AIcon from '../atoms/_atoms.icon';

export default function MInfographic({ title, img, description }) {
	return (
		<article className="m-infographic">
			<p className="title">
				<FormattedMessage id={title} defaultMessage="" />
			</p>
			<figure>
				<img src={img} alt={title} />
			</figure>
			<p>
				<FormattedMessage id={description} defaultMessage="" />
			</p>
		</article>
	);
}

MInfographic.propTypes = {
	title: PropTypes.string.isRequired,
	img: PropTypes.string.isRequired,
	description: PropTypes.string,
};

MInfographic.defaultProps = {
	description: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.infographic.js